
import _debounce from 'lodash.debounce'

export default {
  name: 'FilterBox',
  props: {
    choices: {
      type: Array,
      required: true,
      default: () => [],
    },
    preSelected: {
      type: Array,
      required: false,
      default: () => [],
    },
    name: {
      type: String,
      required: false,
      default: 'tag',
    },
  },
  data() {
    return {
      selected: {},
      showLeft: false,
      showRight: false,
    }
  },
  computed: {
    filterText() {
      if (this.choices.length === 1) {
        return this.name
      }

      switch (this.tags.length) {
        case 0:
          return `Filter by ${this.name}`
        case 1:
          return 'Filter'
        default:
          return 'Filters'
      }
    },
    tags() {
      const tags = []
      Object.entries(this.selected).forEach(([key, value]) => {
        if (value) {
          tags.push(key)
        }
      })

      return tags
    },
    sortedChoices() {
      return [...this.choices].sort()
    },
  },
  watch: {
    preSelected(v) {
      this.initSelected(v)
    },
  },
  mounted() {
    this.initSelected(this.preSelected)

    // only for mobile/tablet where the scrollArea element is present
    if (this.$refs.scrollArea) {
      // show/hide arrows on scroll/resize
      this.$refs.scrollArea.addEventListener(
        'scroll',
        this.handleArrowVisibility
      )
      window.addEventListener('resize', this.handleArrowVisibility)
    }
  },
  beforeDestroy() {
    this.$refs.scrollArea.removeEventListener(
      'scroll',
      this.handleArrowVisibility
    )
    window.removeEventListener('resize', this.handleArrowVisibility)
  },
  methods: {
    initSelected(selected) {
      this.selected = this.choices.reduce(
        (acc, item) => ({ ...acc, [item]: selected.includes(item) }),
        {}
      )
    },
    onChange({ label, selected }) {
      this.selected[label] = selected
      this.$emit('change', this.tags)
    },
    recalculateArrowVisibility() {
      // check if right arrow is needed (if the scroll is actually present)
      const element = this.$refs.scrollArea
      this.showRight = element?.scrollWidth > element?.offsetWidth
    },
    handleArrowVisibility: _debounce(function () {
      const element = this.$refs.scrollArea
      this.showLeft = true
      this.showRight = true

      if (element?.scrollLeft === 0) {
        this.showLeft = false
      }

      if (element?.scrollLeft === element?.scrollWidth - element?.offsetWidth) {
        this.showRight = false
      }
    }, 100),
    slidePrev() {
      const tagElement = this.$refs.tagRef
      const scrollAreaElement = this.$refs.scrollArea
      const scrollPosition = scrollAreaElement?.scrollLeft

      for (const element of tagElement) {
        if (
          element.$el?.offsetLeft + element.$el?.offsetWidth >
          scrollPosition
        ) {
          element.$el?.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'end',
          })
          break
        }
      }
    },
    slideNext() {
      const tagElement = this.$refs.tagRef
      const scrollAreaElement = this.$refs.scrollArea
      const scrollPosition =
        scrollAreaElement?.offsetWidth + scrollAreaElement?.scrollLeft

      for (const element of tagElement) {
        if (
          element.$el?.offsetLeft + element.$el?.offsetWidth >
          scrollPosition
        ) {
          element.$el?.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'start',
          })
          break
        }
      }
    },
  },
}
